import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { dashboardActions } from "redux/Ldb/actions";

const useGetDashboardAnalytics = (analyticsDuration?: string) => {
    const dispatch = useAppDispatch();
    const [analyticsData, setAnalyticsData] = useState<{ [key: string]: any }>([]);

    const {
        fetchingDashboardAnalytics,
        fetchedDashboardAnalyticsSuccess,
        fetchedDashboardAnalyticsFailure,
    } = useAppSelector((state) => state.dashboard);

    useEffect(() => {
        if (Boolean(fetchedDashboardAnalyticsSuccess)) {
            setAnalyticsData(fetchedDashboardAnalyticsSuccess);
        }
    }, [fetchedDashboardAnalyticsSuccess]);

    useEffect(() => {
         dispatch(dashboardActions?.getDashboardAnalytics(analyticsDuration));
    }, [dispatch, analyticsDuration]);

    return {
        data: analyticsData,
        isFetching: fetchingDashboardAnalytics,
        error: fetchedDashboardAnalyticsFailure,
    };
};

export default useGetDashboardAnalytics;
